/*
 * @Author: Fone`峰
 * @Date: 2021-02-07 16:01:33
 * @LastEditors: Fone`峰
 * @LastEditTime: 2021-06-21 14:01:29
 * @Description: file content
 * @Email: qinrifeng@163.com
 * @Github: https://github.com/FoneQinrf
 */
/* eslint-disable */
export default {
  tender: {
    "getHot post": "/v1/yunli-tx/tender/hot", // 获取热门招标
    "getJsSdkSignature get": "/v1/yunli-tx/wechat/getJsSdkSignature", // 获取热门招标
    "detail post": "/v1/yunli-tx/tender/detail", // 招标详情
    "qualificationState post": "/v1/yunli-tx/tender/qualificationState", // 招标单车队报名资质认证状态
    "signUp post": "/v1/yunli-tx/tender/signUp", // 车队报名
    "tenderList post": "/v1/yunli-tx/tender/hall/lower2", // 招标大厅-车队
    "ManagerList post": "/v1/yunli-tx/tender/manager/lower", // 获取投标列表-车队-我的首页/车队投标管理
    "ManagerListUp post": "/v1/yunli-tx/tender/manager/upper", // 获取招标列表-货主-我的首页/货主招标管理
    "lowerBid post": "/v1/yunli-tx/tender/detail/lowerBid", // 获取报名投标详情-车队
    "upperBid post": "/v1/yunli-tx/tender/detail/upper", // 获取招标详情-货主
    "signup post": "/v1/yunli-tx/tender/detail/signup", // 获取已报名车队
    "resp post": "/v1/yunli-tx/tender/detail/resp", // 获取应标车队
    "bid post": "/v1/yunli-tx/tender/detail/bid", // 获取投标车队
    "win post": "/v1/yunli-tx/tender/detail/win", // 获取中标车队
    "upperBidDetail post": "/v1/yunli-tx/tender/detail/upperBid", // 获取报名投标详情-货主
    "bulletin get": "/v1/yunli-tx/tender/bulletin", // 获取热门动态
    "promotion get": "/v1/yunli-tx/tender/promotion", // 获取热门竞标
    // 'lowerTenderCount post': '/v1/yunli-tx/tender/manager/lowerTenderCount', // 获取投标列表各状态数量-车队
  },
  user: {
    "login post": "/v1/yunli-tx/user/login", // 登录
    "register post": "/v1/yunli-tx/user/register", // 注册
    "getUserInfo post": "/v1/yunli-tx/user/baseInfo", // 获取个人信息
    "updateUserInfo post": "/v1/yunli-tx/user/updateUserInfo", // 更新个人信息
    "modifyPasswd post": "/v1/yunli-tx/user/modifyPasswd", // 修改密码
    "modifyUserPasswd post": "/v1/yunli-tx/user/modifyUserPasswd", // 忘记密码
    "resetPassword post": "/v1/yunli-tx/user/resetPassword", // 忘记密码
    "getMobileCode post": "/v1/yunli-tx/user/getMobileCode", // 获取手机验证码
    "getUdeskUrl get": "/v1/yunli-tx/user/getUdeskUrl", //客服
    "loginAfter post": "/v1/yunli-tx/user/loginAfter", // 登录后获取用户信息
  },
  company: {
    "getCompanyBaseInfo post": "/v1/yunli-tx/company/getCompanyBaseInfo", // 获取企业信息
    "updateCompanyBaseInfo post": "/v1/yunli-tx/company/updateCompanyBaseInfo", // 更新企业信息
    "getCompanyCapacityInfo post": "/v1/yunli-tx/company/getCompanyCapacityInfo", // 获取运力信息标签
    "updateCompanyCapacityInfo post":
      "/v1/yunli-tx/company/updateCompanyCapacityInfo", // 更新运力信息标签
    "listCompanyTrucks post": "/v1/yunli-tx/company/listCompanyTrucks", // 获取车辆信息
    "deleteCompanyTruck post": "/v1/yunli-tx/company/deleteCompanyTruck", // 删除车辆信息
    "updateCompanyTruck post": "/v1/yunli-tx/company/updateCompanyTruck", // 新增车辆信息
    "listCompanyLines post": "/v1/yunli-tx/company/listCompanyLines", // 查询运力(同城type: 3线路type: 1)
    "updateCompanyLine post": "/v1/yunli-tx/company/updateCompanyLine", // 更新运力(同城type: 3线路type: 1)
    "deleteCompanyLine post": "/v1/yunli-tx/company/deleteCompanyLine", // 删除运力
    "getCompanyInfoPageThree post": "/v1/yunli-tx/company/getCompanyInfoPageThree", // 获取企业认证信息
    "updateCompanyInfoPageThree post":
      "/v1/yunli-tx/company/updateCompanyInfoPageThree", // 更新企业认证信息
    "getCompanyImages post": "/v1/yunli-tx/company/getCompanyImages", // 获取企业照片
    "saveCompanyImages post": "/v1/yunli-tx/company/saveCompanyImages", // 更新企业照片
  },
  contact: {
    "listContacts post": "/v1/yunli-tx/contact/listContacts", // 获取联系人
    "updateContact post": "/v1/yunli-tx/contact/updateContact", // 更新联系人
    "getContact post": "/v1/yunli-tx/contact/getContact", // 更新联系人
  },
  wechat: {
    "getJsSdkSignature get": "/v1/yunli-tx/wechat/getJsSdkSignature", // 获取微信jsSDK
    "getOpenId post": "/v1/yunli-tx/wechat/getOpenId", // 微信授权登录
    "sweeplogin post": "/v1/yunli-tx/wechat/sweeplogin", // 微信获取openid
  },
};
/* eslint-disable */
